<template>
    <div>

        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <a href="/student/essays/all"><i class="fas fa-pencil-alt mr-1"></i> Redações</a> / <span class="text-muted">Enviar Redação</span>
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                    </div>
                </div>
            </div>
        </div>

        <div class="container mb-4">
            <div class="row">
                <div class="col-sm-9 mx-auto">
                    <b-card class="">
                        <div class="row">
                            <div v-if="leaf" class="pr-3 border-end col-12 col-md-4 d-flex flex-column justify-content-center align-items-center">
                                <div class="p-3 mb-3 rounded-circle bg-light text-primary">
                                    <svg height="42px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                                    </svg>
                                </div>
                                <div class="fw-light text-center mb-2">
                                    Faça o download da folha de redação.
                                </div>
                                <a class="btn fw-bolder btn-link d-flex gap-1 align-items-center" target="_blank" :href="leaf">
                                    Folha de Redação
                                    <svg height="22px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
                                        <path fill-rule="evenodd" d="M10 5a.75.75 0 01.75.75v6.638l1.96-2.158a.75.75 0 111.08 1.04l-3.25 3.5a.75.75 0 01-1.08 0l-3.25-3.5a.75.75 0 111.08-1.04l1.96 2.158V5.75A.75.75 0 0110 5z" clip-rule="evenodd" />
                                      </svg>         
                                </a>
                                  
                            </div>
                            <div class="col-12 " :class="leaf ? 'col-md-8' : '' ">
                                <div class="fs-5 mb-3">Instruções</div>
                                <div class="mb-2 d-flex gap-1 align-items-baseline">
                                    <div class="text-white bg-primary rounded-circle text-center number-circle" >1</div> 
                                    <div>
                                        Escreva sua redação e escaneie a imagem utilizando a câmera do celular ou outro aplicativo como <b class="text-primary">CamScanner</b>.
                                    </div>
                                </div>
                                <div class="mb-2 d-flex gap-1 align-items-baseline">
                                    <div class="text-white bg-primary rounded-circle text-center number-circle" >2</div> 
                                    <div>
                                        Selecione o seu corretor e o modo de tema.
                                    </div>
                                </div>
                                <div class="mb-2 d-flex gap-1 align-items-baseline">
                                    <div class="text-white bg-primary rounded-circle text-center number-circle" >3</div>
                                    <div>
                                        Se escolhido o por tema, escolha o tema desejado e caso escolher tema livre, escolher o modo de correção desejado.
                                    </div>
                                </div>
                                <div class="mb-2 d-flex gap-1 align-items-baseline">
                                    <div class="text-white bg-primary rounded-circle text-center number-circle" >4</div> 
                                    <div>
                                        Selecione a imagem da sua redação, fique atento ao tamanho máximo de <b class="text-primary">5MB</b> e ao formato do arquivo <b class="text-primary">.jpeg, .jpg, .png etc</b>.
                                    </div>
                                </div>
                            </div>
                        </div>


                    </b-card>
                </div>
                <div class="col-sm-9 mx-auto">
                    <b-overlay :show="loading" rounded="sm">
                        <b-card>
                            <b-form @submit="submit" @submit.stop.prevent>

                                <!-- Field -->
                                <b-form-group
                                    v-if="!task && forceTeacher"
                                    label="Corretor"
                                    description="Tem preferência por algum corretor em específico?">

                                    <!-- Input -->
                                    <multiselect
                                        v-model="teacher"
                                        :options="teachers"
                                        track-by="id"
                                        label="name"
                                        placeholder=""
                                        @select="selectTeacher"
                                        @remove="removeTeacher"
                                        tag-placeholder="Filtrar Corretor"
                                        selectLabel="Selecionar"
                                        deselectLabel="Desmarcar"
                                        selectedLabel="Selecionado">

                                            <span slot="noResult">
                                                Ops! Nenhum resultado encontrado na pesquisa :(
                                            </span>

                                            <span slot="noOptions">
                                                Não há corretores para exibir no momento :(
                                            </span>

                                    </multiselect>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="teacher_id" />
                                </b-form-group>


                                <div v-show="form.content_type !== 'TEXT'">
                                    <!-- Field -->
                                    <b-form-group
                                        v-if="!task && ! blockThemes"
                                        label="Modo de Tema"
                                        description="Qual o modo de tema que deseja enviar a redação? Específico ou Livre?">
    
                                        <!-- Input -->
                                        <b-form-radio v-model="form.type" name="type" value="theme">
                                            Quero indicar um tema específico para a redação.
                                        </b-form-radio>
                                        <b-form-radio v-model="form.type" name="type" value="mode">
                                            Quero um tema livre para a redação.
                                        </b-form-radio>
    
                                        <!-- Error -->
                                        <has-errors :errors="errors" name="type" />
                                    </b-form-group>

                                    <!-- Field -->
                                    <b-form-group
                                        v-if="form.type === 'theme' && !task"
                                        label="Tema"
                                        description="Qual é o tema da redação?">
    
                                        <!-- Input -->
                                        <multiselect
                                            v-model="theme"
                                            :options="themes"
                                            :loading="loadingTheme"
                                            track-by="id"
                                            label="title"
                                            placeholder=""
                                            @select="(value) => this.form.theme_id = value.id"
                                            @remove="() => this.form.theme_id = null"
                                            @search-change="searchTheme"
                                            tag-placeholder="Filtrar Tema"
                                            selectLabel="Selecionar"
                                            deselectLabel="Desmarcar"
                                            selectedLabel="Selecionado">
    
                                            <span slot="noResult">
                                                Ops! Nenhum resultado encontrado na pesquisa :(
                                            </span>
    
                                            <span slot="noOptions">
                                                Não há temas disponíveis para exibir :(
                                            </span>
    
                                        </multiselect>
    
                                        <!-- Error -->
                                        <has-errors :errors="errors" name="theme_id" />
                                    </b-form-group>
                                    <!-- Field -->
                                    <b-form-group
                                        v-if="form.type === 'mode' && !task"
                                        label="Modo de Correção"
                                        description="Qual é o modo de correção que a redação deve ser corrigida ?">
                                        <!-- Input -->
                                        <multiselect
                                            v-model="mode"
                                            :options="modes"
                                            :loading="loading"
                                            track-by="id"
                                            label="name"
                                            placeholder=""
                                            @select="(value) => this.form.mode_id = value.id"
                                            @remove="() => this.form.mode_id = null"
                                            tag-placeholder="Filtrar Modo de Correção"
                                            selectLabel="Selecionar"
                                            deselectLabel="Desmarcar"
                                            selectedLabel="Selecionado">
    
                                            <span slot="noResult">
                                                Ops! Nenhum resultado encontrado na pesquisa :(
                                            </span>
    
                                            <span slot="noOptions">
                                                Não há modos de correção para exibir :(
                                            </span>
                                        </multiselect>
    
                                        <!-- Error -->
                                        <has-errors :errors="errors" name="mode_id" />
                                    </b-form-group>
                                </div>



                                <!-- Field -->
                                <b-form-group
                                    v-if="form.type === 'mode' && forceModeDocuments"
                                    label="Envie o Texto Motivador"
                                    description="Anexe arquivos que vão ajudar o corretor a saber qual foram os textos motivadores que você baseou sua redação.">

                                    <s3-file-input
                                        id="fileDocuments"
                                        @success="handleDocumentSuccess"
                                        accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                        placeholder=""
                                        browse-text="Procurar"
                                        path="documents"
                                        multiple
                                        no-drop
                                        :maxFileSize="5242880"
                                    ></s3-file-input>

                                </b-form-group>

                                <div v-if="form.type === 'mode' && forceModeDocuments" class="mb-3 form-row">
                                    <div v-for="(documentItem, key) in form.documents" :key="documentItem.id" class="col-sm-3">
                                        <div class="p-2 bg-light rounded">
                                            <div>
                                                <div v-if="documentItem.extension === 'pdf'">
                                                    <a :href="documentItem.preview" target="_blank">
                                                        <i class="fas fa-file-pdf mr-1"></i>
                                                        {{ documentItem.name }}
                                                    </a>
                                                </div>

                                                <div v-if="documentItem.extension === 'docx' || documentItem.extension === 'doc'">
                                                    <a :href="documentItem.preview" target="_blank">
                                                        <i class="fas fa-file-word mr-1"></i>
                                                        {{ documentItem.name }}
                                                    </a>
                                                </div>

                                                <div v-else>
                                                    <div>
                                                        <img :src="documentItem.preview" class="img-thumbnail" width="130px" height="130px" alt="preview" />
                                                    </div>
                                                    <i class="fas fa-file-image mr-1"></i>
                                                    {{ documentItem.name }}
                                                </div>
                                            </div>
                                            <div class="mt-1">
                                                <a href="javascript:void(1);" @click="removeDocument(key)" class="btn btn-sm btn-outline-danger">
                                                    Remover
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <b-alert :show="loadingDocument" variant="info">
                                    <b-spinner class="mr-2" size="sm"></b-spinner>
                                    Salvando arquivo ....
                                </b-alert>

                                
                                <!-- Field
                                <div class="alert alert-primary" v-show="form.content_type === 'TEXT' && typedEssay">
                                    O modo digitado no momento apenas tem suporte ao modo de correção Enem. Redações digitadas serão definidas como modo enem
                                </div>
                                 
                                <b-form-group
                                    v-show="typedEssay"
                                    label="Modo de Envio"
                                    description="Qual o modo de envio que deseja enviar a redação ?">
                                    <b-form-radio v-model="form.content_type" name="content_type" value="IMG">
                                        Quero enviar a redação através de uma foto que tirei e tenho salva no meu computador/celular.
                                    </b-form-radio>
                                    <b-form-radio v-model="form.content_type" name="content_type" value="TEXT">
                                        Quero enviar a redação digitando ela por completa através do meu teclado.
                                    </b-form-radio>

                                    <has-errors :errors="errors" name="content_type" />
                                </b-form-group>
                                -->

                                <!-- Field -->
                                <b-form-group
                                    v-if="form.content_type === 'TEXT' && !task"
                                    label="Texto da Redação"
                                    description="Escreva o conteúdo da redação a ser corrigida">
                                    <!-- Input -->
                                    <div id="essay-main">
                                        <textarea
                                            id="area"
                                            ref="area"
                                            rows="30"
                                            class="essay-textarea essay-notes"
                                            v-model="form.content_text"
                                            @keydown="textKeyDown"
                                            @keyup="textKeyUp"
                                        >
                                        </textarea>
                                    </div>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="content_text" />
                                </b-form-group>

                                <div v-if="!!task">
                                    <b-form-group
                                        label="Material Complementar"
                                        v-if="task.documents.length > 0"
                                    >
                                        <div v-for="(documentItem) in task.documents" :key="documentItem.id" class="d-flex">
                                            <div class="text-muted">
                                                <i class="fas fa-file mr-2"></i>
                                                {{ documentItem.name }}
                                            </div>
                                            <div class="ml-3 text-right">
                                                <a :href="documentItem.preview" target="_blank">
                                                    Ver Material
                                                </a>
                                            </div>
                                        </div>
                                    </b-form-group>
                                </div>

                                <!-- Message Task -->
                                <b-alert variant="info" :show="!!task">
                                    Esse é um envio específico para uma atividade. Envie a imagem da redação no campo abaixo para concluir :)
                                </b-alert>

                                <!-- Field -->
                                <b-form-group
                                    v-if="form.content_type === 'IMG'"
                                    label="Imagem da Redação"
                                    description="Envie a imagem da redação que será corrigida">

                                    <s3-file-input
                                        id="imageFile"
                                        @success="handleImageSuccess"
                                        accept="image/*"
                                        placeholder=""
                                        browse-text="Procurar"
                                        path="essays"
                                        :can-clear="true"
                                        :disabled="!!form.content_img_path || !!imageConvertPath"
                                        no-drop
                                        :max-file-size="5242880"
                                    ></s3-file-input>

                                    <div v-if="imageConvertPath">
                                        <b-alert variant="info" class="mt-2" show>
                                            <b-spinner class="mr-2" small></b-spinner>
                                            convertendo a imagem, aguarde alguns instantes ...
                                        </b-alert>
                                    </div>

                                    <div v-if="form.content_img_path" class="mt-2">
                                        <b-button @click="clearImage" variant="outline-danger" size="sm" v-b-tooltip.hover title="Remover Imagem">
                                            <!-- Change Icon -->
                                            <i class="fas fa-trash"></i>
                                        </b-button>
                                        <img :src="preview" class="img-thumbnail mt-2" width="100%" alt="" />
                                    </div>

                                    <!-- Error -->
                                    <has-errors :errors="errors" name="content_img_path" />
                                </b-form-group>

                                <!-- Submit -->
                                <b-button type="submit" variant="primary" :disabled="loading || (!form.content_img_path && form.content_type === 'IMG')">
                                    Enviar Redação
                                </b-button>

                                <!-- Cancel -->
                                <a @click="cancelEssay('/student/essays/all')" class="ml-2 btn btn-outline-secondary">
                                    Cancelar
                                </a>
                            </b-form>
                        </b-card>
                    </b-overlay>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Cropper
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
// Editor
import { quillEditor } from 'vue-quill-editor'

export default {
    components: {
        Cropper,
        quillEditor
    },
    props: ['endpoint', 'task','leaf', 'modes', 'teachers', 'forceTeacher', 'blockThemes', 'forceModeDocuments', 'themeQuery', 'typedEssay'],
    data() {
        return {
            loading: false,
            loadingTheme: false,
            loadingOptimize: false,
            loadingDocument: false,
            editorOption: {
                placeholder: 'Aqui você escreve a redação ...',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['clean']
                    ],
                }
            },
            errors: {},
            form: {
                type: this.blockThemes ? 'mode' : 'theme',
                teacher_id: null,
                theme_id: null,
                mode_id: null,
                content_type: 'IMG',
                content_text: null,
                content_img_path: null,
                task_id: null,
                documents: []
            },
            teacher: null,
            theme: null,
            mode: null,
            preview: null,
            text_saved: null,
            preview_saved: null,
            img_saved: null,
            themes: [],
            key: {
                tabKey:9,
                ctrlKey:17,
                pageupKey:33,
                pagedownKey:34,
                leftKey:37,
                upKey:38,
                rightKey:39,
                downKey:40,
                delKey:46,
                aKey:65,
                cKey:67,
                sKey:83,
                vKey:86,
                xKey:88,
                yKey:89,
                zKey:90
            },
            lastEssayText: null,
            imageConvertInterval: null,
            imageConvertPath: null,
            imageConvertIntervalTime: 10000,
        }
    },
    watch: {
        'form.type': function (type) {
            if (type === 'theme') {
                this.form.mode_id = null;
                this.mode = null;
            }
            if (type === 'mode') {
                this.form.theme_id = null;
                this.theme = null;
            }
        },
        'form.content_type': function (type) {
            if (type === 'TEXT') {

                // Prev State
                this.form.content_text = this.text_saved
                this.preview_saved = this.preview;
                this.img_saved = this.form.content_img_path

                //get documents the mode selected will be selected in the backend while enem is only suported in this method
                this.form.type = 'mode'
                this.form.mode_id = this.modes.length > 0 ? this.modes[0].id : null

                // Clear
                this.form.content_img_path = null;
                this.preview = null;
            }

            if (type === 'IMG') {

                // Prev State
                this.preview = this.preview_saved;
                this.form.content_img_path = this.img_saved
                this.text_saved = this.form.content_text

                // Clear
                this.form.content_text = null
            }
        }
    },
    created() {

        // Themes Init Search
        this.searchTheme(null)

        // Check if exist text saved
        if (localStorage.getItem('createEssay') !== '') {
            let text = localStorage.getItem('createEssay')
            if (text !== 'null') {
                this.form.content_text = text
            }
        }

        if (this.themeQuery) {
            this.form.type = 'theme';
            this.form.theme_id = this.themeQuery.id;
            this.theme = this.themeQuery;
        }

        // Check if is Task
        if (this.task) {

            if (this.task.theme_id) {
                this.form.type = 'theme';
            } else {
                this.form.type = 'mode';
            }

            this.form.teacher_id = this.task.teacher_id;
            this.teacher = this.task.teacher;
            this.form.theme_id = this.task.theme_id;
            this.theme = this.task.theme;
            this.form.mode_id = this.task.mode_id;
            this.mode = this.task.mode;
            this.form.task_id = this.task.id;

        }

    },
    methods: {

        submit() {
            this.loading = true;

            axios.post(this.endpoint, {
                ...this.form,
                documents: this.form.documents.map((item) => {
                    return item.id
                })
            })
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

        searchTheme(text) {
            this.loadingTheme = true;
            axios.get('/student/themes/search', {
                params: {
                    title: text
                }
            })
                .then((result) => {
                    this.themes = result.data.data.themes;
                })
                .finally(() => this.loadingTheme = false)
        },

        loadImage() {
            if (this.$refs.file.files[0]) {
                this.optimizeImage(this.$refs.file.files[0])
            }
        },

        async loadDocuments() {
            for (let index = 0; index < this.$refs.fileDocuments.files.length; index++) {
                await this.uploadDocument(this.$refs.fileDocuments.files[index])
            }
        },

        async uploadDocument(inputFile) {
            // block files more than 5mb exact bytes
            if (inputFile.size > 5242880) {
                this.$toast.error('O arquivo ' + inputFile.name + ' ultrapassa o limite de 5mb');
                return;
            }

            this.loadingDocument = true;

            let formData = new FormData();
            formData.append('document', inputFile)

            await axios.post('/student/essay-documents', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((result) => {
                    let response = result.data.data;

                    if (response.document) {
                        this.form.documents.push(response.document);
                    }
                })
                .finally(() => this.loadingDocument = false)
        },

        removeDocument(key) {
            this.form.documents.splice(key, 1)
        },

        optimizeImage(inputImage) {

            this.loadingOptimize = true;

            let formData = new FormData();

            formData.append('image', inputImage)

            axios.post('/student/essays/optimize-image', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((result) => {

                    this.preview = result.data.data.urlImage

                })
                .finally(() => this.loadingOptimize = false)
        },

        selectTeacher(value) {
            this.form.teacher_id = value.id;
        },

        removeTeacher() {
            this.form.teacher_id = null
            this.teacher = null
        },

        cropImage() {
            const { canvas } = this.$refs.cropper.getResult();
            this.form.content_img_path = canvas.toDataURL();
        },

        changeImage() {
            this.preview = null;
            this.form.content_img_path = null
        },

        async textKeyDown(e) {
            let evtobj = e;
            let ctrlKey = evtobj.ctrlKey;
            let keyCode = evtobj.keyCode;

            if( ctrlKey ) {

                if( keyCode === this.key.aKey ) {
                    this.$refs.area.focus();
                }

                if( keyCode === this.key.sKey ) {
                    e.preventDefault();
                    return false;
                }

                // Ctrl+Z
                if( keyCode === this.key.zKey ) {
                    e.preventDefault();
                }

                // Ctrl+Y
                if( keyCode === this.key.yKey ) {
                    e.preventDefault();
                }

                // Ctrl+C
                if( keyCode === this.key.cKey ) {
                    //e.preventDefault();
                }

                // Ctrl+V
                if( keyCode === this.key.vKey ) {
                    //e.preventDefault();
                }

                // Ctrl+X
                if( keyCode === this.key.xKey ) {
                    e.preventDefault();
                }
            }

            // page up/down
            if( keyCode === this.key.upKey || keyCode === this.key.downKey ) {
                this.$refs.area.focus();
            }

            // tab
            if( keyCode === this.key.tabKey ) {
                e.preventDefault();
                // this.form.content_text = await this.form.content_text + '\u0009';
            }

            // Save in Storage
            localStorage.setItem('createEssay', this.form.content_text);
        },

        textKeyUp(event) {
        },

        cancelEssay(href) {
            localStorage.removeItem('createEssay');
            window.location = href
        },

        rotate(angle) {
            this.$refs.cropper.rotate(angle);
        },

        handleImageSuccess(data) {
            if (data.pathConverted) {

                if (this.imageConvertInterval) {
                    clearInterval(this.imageConvertInterval)
                }

                this.imageConvertPath = data.pathConverted;

                this.imageConvertInterval = setInterval(() => {
                    axios.post('/check-if-path-exists', {
                        path: this.imageConvertPath
                    })
                        .then((result) => {
                            let response = result.data;

                            if (response.exist) {
                                this.preview = response.url;
                                this.form.content_img_path = this.imageConvertPath;

                                this.imageConvertPath = null;
                                clearInterval(this.imageConvertInterval)
                            }
                        })
                }, this.imageConvertIntervalTime)

            } else {

                if (this.imageConvertInterval) {
                    clearInterval(this.imageConvertInterval)
                }

                this.imageConvertPath = null;
                this.preview = data.url;
                this.form.content_img_path = data.path;
            }
        },

        clearImage() {
            this.preview = null;
            this.form.content_img_path = null;
        },

        async handleDocumentSuccess(data) {
            this.loadingDocument = true;

            await axios.post('/student/essay-documents', data)
                .then((result) => {
                    let response = result.data.data;

                    if (response.document) {
                        this.form.documents.push(response.document);
                    }
                })
                .finally(() => this.loadingDocument = false)
        },
    }
}
</script>

<style scoped>
.cropper {
    background: #DDD;
}

.number-circle{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px !important; 
    min-width: 22px !important; 
    height: 22px !important;
    min-height: 22px !important;
    padding: 5px !important;
    text-align: center !important; 
}
</style>
